// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import { Theme, createStyles, makeStyles } from "@material-ui/core";

import { DeclarativeContent } from "components/DeclarativeComponents/DeclarativeContentTypes";
import { fbt } from "fbt";

export const FORMID = "stepForm";

export const UNSET_PROFILE_ID = "UNSET_PROFILE_ID";
export const UNSET_USER_ID = "UNSET_USER_ID";

export const getStepStyle = makeStyles((theme: Theme) =>
  createStyles({
    bulletList: {
      listStyleType: "square",
      paddingLeft: "1em",
      listStylePosition: "outside",
      "& li": {
        margin: "1rem 0",
      },
    },
    centeredAsset: {
      display: "block",
      margin: "2rem auto",
    },
  })
);

interface NavLink {
  default: string; // default step name for the nav.
  [type: string]: string; // Other possible links.
}

export interface TestRunParams {
  step: string;
  testRunUID: string;
}

interface StepDetailsIncomplete {
  contentDescription: DeclarativeContent;
  skipStepForExistingUser?: boolean;
  // this step has a form blocking progress to the next step.
  hasFormContent?: boolean;
  isBlockingStep?: boolean;
  nav: {
    previous?: string;
    next?: NavLink;
  };
}

export interface StepDetails extends StepDetailsIncomplete {
  name: string;
}

export interface IncompleteStepsDefinition {
  [stepName: string]: StepDetailsIncomplete;
}

export interface StepsDefinition {
  [stepName: string]: StepDetails;
}

export const START_STEP = "gettingStarted";

export function getSteps(): IncompleteStepsDefinition {
  return {
    gettingStarted: {
      contentDescription: [
        {
          type: "Asset",
          props: {
            height: 200,
            width: 300,
            alt: fbt(
              "Kit box and tissues on a table.",
              "starting step: image alt attribute",
              { project: "audere" }
            ),
            src: "gettingstarted.png",
          },
          display: "centered",
        },
        {
          type: "Title",
          props: {
            content: fbt("Let's get started", "starting step: page title", {
              project: "audere",
            }),
          },
        },
        {
          type: "Paragraph",
          props: {
            content: fbt(
              "Please configure the steps of your custom area via a config file.",
              "starting step: intro text",
              {
                project: "audere",
              }
            ),
          },
        },
      ],
      nav: {},
    },
  };
}
